import { faCircle } from '@fortawesome/pro-solid-svg-icons';
import { format } from 'date-fns';
import { sortBy } from 'lodash';

import { RosterDay } from '../../types';
import { OpenRequestsRow as OpenRequestsRowType } from './types';
import { PlanUnit } from 'components/types';

import { getCellDateClasses } from '../../utils';
import { getHoursMinutesSeconds } from 'utils/date';

import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

import { FontAwesomeSvgIcon } from 'components/shared';

import Duty from '../Duty';

type Props = {
  openRequestsRow: OpenRequestsRowType;
  selectedPlanUnits: PlanUnit[];
  rosterDays: RosterDay[];
  portal: string;
};

export default function OpenRequestsRow({
  openRequestsRow,
  selectedPlanUnits,
  rosterDays,
  portal
}: Props) {
  const { function: func, planUnitName } = openRequestsRow;

  return (
    <TableRow>
      <TableCell>
        <div className="function-container semibold">
          {func.colorCode && (
            <span className="function-color" style={{ color: func.colorCode }}>
              <FontAwesomeSvgIcon
                color="inherit"
                icon={faCircle}
                fontSize="small"
              />
            </span>
          )}
          {func.name}
        </div>
        {selectedPlanUnits.length > 1 && <div>{planUnitName}</div>}
      </TableCell>
      {rosterDays.map(({ day, date }) => {
        const days = openRequestsRow.days[format(date, 'yyyy-MM-dd')];
        return (
          <TableCell key={day} className={getCellDateClasses({ date })}>
            {days &&
              sortBy(days, [
                (duty) => getHoursMinutesSeconds(duty.periods[0].start),
                (duty) => getHoursMinutesSeconds(duty.periods[0].end)
              ]).map((duty) => (
                <Duty key={duty.requestId} duty={duty} portal={portal} />
              ))}
          </TableCell>
        );
      })}
    </TableRow>
  );
}
